import React, { useState } from 'react'
import { Link } from "react-router-dom"

function HeaderPlayerMenu( data ) {

  const mobileMenuIcon = <div className='headerPlayerMenuMobile' onClick={ toggleMenu }>{
    data.user ?
    <div className='mobileMenuIcon_Authorized'>
      <img className='headerPlayerMenuAvatar' src={ './images/petAvatars/' + data.user.avatar + '.jpeg' }></img>
      <div className='mobileMenuIcon'>
        <svg className='buttonIcon' viewBox="0 0 23 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="4" y="2" width="16" height="2" rx="1" fill="white"/>
          <rect x="4" y="7" width="16" height="2" rx="1" fill="white"/>
          <rect x="4" y="12" width="16" height="2" rx="1" fill="white"/>
        </svg>
      </div>
    </div> :
    <div className='mobileMenuIcon' onClick={ data.toggleMenu }>
      <svg className='buttonIcon' viewBox="0 0 23 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="4" y="2" width="16" height="2" rx="1" fill="white"/>
        <rect x="4" y="7" width="16" height="2" rx="1" fill="white"/>
        <rect x="4" y="12" width="16" height="2" rx="1" fill="white"/>
      </svg>
    </div>
  }</div>

  const desktopMenuIcon = ()=>{
    return(
      data.user ?
      <div className='headerPlayerMenu' onClick={ toggleMenu }>
        <img className='headerPlayerMenuAvatar' src={ './images/petAvatars/' + data.user.avatar + '.jpeg' }></img>
        <div className="headerPlayerMenuAvatarNameWrapper"><p className="headerPlayerMenuAvatarName">{data.user.first_name}</p></div>
      </div> : null
    )
  }

  function toggleMenu(){
    data.toggleSiteMenu( true )
  }

  if( data.width < 1000 ) return ( mobileMenuIcon )
    else return ( desktopMenuIcon() )
  }

export default HeaderPlayerMenu;
